import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { isRegisteredLocale, localeRegistry } from './localeRegistry'

const fallbackLocale = 'en'

const resources = Object.fromEntries(
  localeRegistry.map((locale) => [locale.code, { translation: locale.translation }]),
)

function resolveInitialLocale(): string {
  const saved = typeof localStorage === 'undefined' ? null : localStorage.getItem('nf.locale')
  if (isRegisteredLocale(saved)) return saved

  const browserLanguage = typeof navigator !== 'undefined' && typeof navigator.language === 'string' ? navigator.language : ''
  const browserPrefix = browserLanguage.split('-')[0]
  if (isRegisteredLocale(browserPrefix)) return browserPrefix

  return fallbackLocale
}

const lng = resolveInitialLocale()

void i18n.use(initReactI18next).init({
  resources,
  lng,
  fallbackLng: fallbackLocale,
  interpolation: { escapeValue: false },
})

export default i18n
